const SupportPage = () => {
  const email = "info@mynota.io";
  return (
    <div className="legal-page">
      <h1>Support</h1>
      <p>
        Need help with My Nota? We’re here for you. Reach out anytime and we’ll
        get back to you as soon as we can.
      </p>

      <h2>Contact Us</h2>
      <p>
        Email support at <a href={`mailto:${email}`}>{email}</a>.
      </p>

      <h2>How to Delete Your Account</h2>
      <p>
        You can delete your My Nota account from within the app. Follow these
        steps:
      </p>
      <ol>
        <li>Go to the "Notebook" tab.</li>
        <li>Tap on Settings.</li>
        <li>Scroll to the bottom.</li>
        <li>Tap on "Delete My Account".</li>
        <li>Tap on "Delete Account" on the confirmation screen.</li>
      </ol>
      <p>
        If you have trouble deleting your account, contact us at{" "}
        <a href={`mailto:${email}`}>{email}</a> and we’ll help you complete the
        process.
      </p>
    </div>
  );
};

export default SupportPage;
